import { TimelineRow } from "@app/components/assistant/conversation/actions/inline/TimelineRow";
import { AnimatedText, ChevronRight, Icon } from "@dust-tt/sparkle";
import { memo } from "react";

interface ThinkingStepProps {
  content: string;
  isStreaming: boolean;
  isMessageDone: boolean;
  isLast: boolean;
  onClick?: () => void;
}

export const ThinkingStep = memo(function ThinkingStep({
  isStreaming,
  isLast,
  onClick,
}: ThinkingStepProps) {
  if (isStreaming) {
    return (
      <TimelineRow spinner isLast={isLast}>
        <span className="text-xs text-muted-foreground flex items-center gap-1">
          <AnimatedText>Thinking…</AnimatedText>
        </span>
      </TimelineRow>
    );
  }

  const row = (
    <TimelineRow icon="circle" isLast={isLast}>
      <span className="text-xs text-muted-foreground flex items-center gap-1">
        Thinking process
        {onClick && (
          <Icon size="xs" visual={ChevronRight} className="opacity-50" />
        )}
      </span>
    </TimelineRow>
  );

  if (onClick) {
    return (
      <div className="cursor-pointer" onClick={onClick}>
        {row}
      </div>
    );
  }

  return row;
});
